import { Route } from '@angular/router';
import { PublicComponent } from './public.component';
export const publicRoutes: Route[] = [
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./authentication/authentication.component').then(
            (m) => m.AuthenticationComponent
          ),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },

  // {
  //   path: '**',
  //   redirectTo: 'secure/dashboard',
  // },
];
